import { DriverUnits, NO_DEFAULT } from '@automata/wfb-api';
import isNil from 'lodash/isNil';

import type { TaskParameterValue } from '../../../../types';

export const isTimeField = (units: DriverUnits | null): boolean => {
  return units === 'seconds';
};

export const paramToString = (
  param: TaskParameterValue | null | undefined
): string => {
  return isNil(param) || param === NO_DEFAULT ? '' : String(param);
};

export const setDefaultSlotValue = (
  capacity: number,
  labwareIdsSlots: Record<string, string | null> | undefined
): string => {
  if (capacity <= 0) return '1';

  // Always pick the first unused slot irrespective of instrument type.
  const arrayOfSlots = [...Array(capacity).keys()].map((i) => i + 1);
  const usedSlots = Object.values(labwareIdsSlots ?? {}).map((v) =>
    Number(v ?? 0)
  );
  const firstAvailableSlot = arrayOfSlots.find(
    (slot) => !usedSlots.includes(slot)
  );

  return String(firstAvailableSlot ?? 1);
};
